export default "__VITE_ASSET__CAcAdbyx__"